import React, { useEffect, useRef, useState } from 'react';
import { getService } from '@Shared.Angular/flowingly.hooks/useService';
import { UserNotificationsPanel } from './UserNotificationsPanel';
import IconButton from '@Shared.Angular/flowingly.components/buttons/IconButton';
import { IUserNotificationsReadMessage } from '@Shared.Angular/@types/pubSub';

const subscriberId = 'runner.user.notifications';

export const UserNotificationsMenuItem = () => {
  const [isOpen, setIsOpen] = useState(false);
  const [notificationCount, setNotificationCount] = useState(
    getService('userNotificationsApiService').notificationCount
  );
  const notificationElement = useRef<HTMLDivElement | null>(null);
  const userNotificationsApiService = getService('userNotificationsApiService');

  useEffect(() => {
    userNotificationsApiService
      .getNotificationCount(false)
      .then(() =>
        setNotificationCount(userNotificationsApiService.notificationCount)
      );

    getService('pubsubService').subscribeLate(
      'SIGNALR_USER_NOTIFICATION_CREATED',
      () => {
        setNotificationCount(userNotificationsApiService.notificationCount);
      },
      subscriberId
    );
    getService('pubsubService').subscribeLate(
      'SIGNALR_USER_NOTIFICATIONS_READ',
      (event, message: IUserNotificationsReadMessage) => {
        setNotificationCount(userNotificationsApiService.notificationCount);
      },
      subscriberId
    );
    getService('pubsubService').subscribeLate(
      'SIGNALR_USER_NOTIFICATION_DISMISSED',
      () => {
        setNotificationCount(userNotificationsApiService.notificationCount);
      },
      subscriberId
    );

    return () => getService('pubsubService').unsubscribeAll(subscriberId);
  }, []);

  useEffect(() => {
    const closeOnOutsideClick = (event: MouseEvent): void => {
      const target = event.target;
      if (!(target instanceof HTMLElement)) return;
      if (notificationElement.current?.contains(target)) return;
      if (target.closest('.user-notifications')) {
        return;
      }

      setIsOpen(false);
    };

    window.addEventListener('click', closeOnOutsideClick);
    return () => window.removeEventListener('click', closeOnOutsideClick);
  }, []);

  return (
    <div className="user-notifications-menu-item" ref={notificationElement}>
      <IconButton
        onClick={() => setIsOpen((currentlyOpen) => !currentlyOpen)}
        title="Notifications"
        testId="user-notifications-toggle"
        iconClass="fa-bell"
        badgeText={notificationCount > 0 ? notificationCount : undefined}
      />

      {isOpen && (
        <div className="user-notifications-menu-item__panel-container">
          <div className="user-notifications-menu-item__panel-container__heading">
            Notifications
          </div>
          <UserNotificationsPanel onClose={() => setIsOpen(false)} />
        </div>
      )}
    </div>
  );
};
